import React, {useRef, useState, useEffect} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowDown, faSliders, faRefresh, faEraser } from '@fortawesome/free-solid-svg-icons';
import { toPng } from 'html-to-image';
import Editor from '@monaco-editor/react';
import Select from 'react-select'
import StyledSelect from '../components/StyledSelect'
import { dark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
// import SyntaxHighlighter from 'react-syntax-highlighter';
import { Tooltip } from 'flowbite';
import ColorPicker from 'react-best-gradient-color-picker'
import commonFunc from '../common';
import EditableCodeHighlighter from '../components/EditableCodeHighlighter'

const codeString = `const greet = (name) => {
  return \`Hello, \${name}!\`;
}
console.log(greet('World'));
  `;
const defaultSettings = {
  width: 700,
  height: 393.75,
  editorWidth: 700 * 0.6,
  editorHeight: 200,
  paddingX: 100,
  paddingY: 50,
  showLineNumbers: false,
  wrapLines: true,
  showInlineLineNumbers: false,
  startingLineNumber: 1,
  fontFamily: 'Arial'
}

const bgColorReady = commonFunc.bgColorReady

const CodeToImagePage = (props) => {
  const codeRef = useRef();
  const editorPreview = useRef();
  const { editorTheme, appTheme } = props
  const [originalInput, setOriginalinput] = useState(codeString);
  const [language, setLanguage] = useState(commonFunc.langOptions.filter((l) => l.value === 'javascript')[0])
  const [style, setStyle] = useState(commonFunc.styleOptions.filter((st) => st.value === 'dark')[0])
  const [currentStyle, setCurrentStyle] = useState(dark)
  const [styles, setStyles] = useState(null)
  const [bgColor, setBGColor] = useState('transparent')
  const [imageSettings, setImageSettings] = useState(defaultSettings)
  const [hasBackground, setHasBackground] = useState(true)
  const [color, setColor] = useState('linear-gradient(135deg, rgb(54, 209, 220) 0%, rgb(91, 134, 229) 100%)');
  const [aspectRatio, setAspectRatio] = useState('16:9');
  const [watermark, setWatermark] = useState(null)
  const [downloadFileName, setDownloadFileName] = useState('DownloadFileName')
  const [colorTab, setColorTab] = useState(0)
  const [selectBgColorReady, setSelectBgColorReady] = useState(null)

  const handleResetToDefault = () => {
    setHasBackground(true)
    setImageSettings(defaultSettings)
  }

  const handleChangeAspectRatio = (e) => {
    const newValue = e.target.value
    setAspectRatio(newValue)
    const height = calculateHeight(newValue)
    setImageSettings({ ...imageSettings, height: height })
  }

  const calculateHeight = (newAspectRatio) => {
    const [widthRatio, heightRatio] = newAspectRatio.split(':').map(Number);
    const height = (imageSettings.width * heightRatio) / widthRatio;
    return height
  }

  const handleHasBackgroundChange = () => {
    const newValue = !hasBackground
    setHasBackground(newValue)
    const height = calculateHeight(aspectRatio)
    if (newValue) {
      const editorWidth = imageSettings.width * 0.5
      setImageSettings({ ...imageSettings, editorWidth: editorWidth, height: height })
    } else {
      setImageSettings({ ...imageSettings, editorWidth: imageSettings.width, height: height })
    }
  }

  const handleDownload = () => {
    if (codeRef.current === null) {
      return;
    }
    toPng(codeRef.current, { cacheBust: true })
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.download = `${downloadFileName}.png` || 'toolover-code.png';
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.error('Oops, something went wrong!', err);
      });
  };

  const handleLangSelectChange = (option) => {
    setLanguage(option)
  }

  const handleSelectBgColorReadyChange = (option) => {
    setSelectBgColorReady(option)
    setColor(option.value)
  }

  const handleStyleSelectChange = (option) => {
    setStyle(option)
    setCurrentStyle(styles[option.value])
    setBGColor(styles[option.value].hljs.background)
    // setBGColor(styles[option.value][':not(pre) > code[class*="language-"]'].background)
  }
  const handleImageUpload = () => {
  }
  const handleImageSettingsChange = (e) => {
    let newValue = e.target.value
    setImageSettings({
      ...imageSettings,
      [e.target.name]: newValue,
    })
  }

  const handleImageSettingsCheckbox = (e) => {
    const newValue = !imageSettings[e.target.name]
    console.log(`${e.target.name}`, newValue)
    setImageSettings({
      ...imageSettings,
      [e.target.name]: newValue,
    })
  }

  const options = {
    placement: 'bottom',
    triggerType: 'none',
    onHide: () => {
        console.log('tooltip is shown');
    },
    onShow: () => {
        console.log('tooltip is hidden');
    },
    onToggle: () => {
        console.log('tooltip is toggled');
    },
  }; 

  const handleShowTooltipColor = () => {
    const instanceOptions = {
      id: 'popover-user-profile',
      override: true
    };
    const $targetElColor = document.getElementById('popover-user-profile');
    const $triggerElColor = document.getElementById('color-tooltip');
    const tooltipColor = new Tooltip($targetElColor, $triggerElColor, options, instanceOptions);
    tooltipColor.init()
    tooltipColor.show()
  }

  const handleShowTooltipSettings = () => {
    const $targetElSettings = document.getElementById('popover-settings')
    const $triggerElSettings = document.getElementById('popover-settings-btn');
    const instanceOptionsSetting = {
      id: 'popover-settings',
      override: true
    };
    const tooltipSetting = new Tooltip($targetElSettings, $triggerElSettings, options, instanceOptionsSetting);
    tooltipSetting.init()
    tooltipSetting.show()
  }

  const handleChangeOriginalInput = (value) => {
    setOriginalinput(value)
  }

  useEffect(() => {
    if (!styles) {
      commonFunc.loadStyles().then((stylesMap) => {
        setStyles(stylesMap)
        const newStyle = stylesMap['dark']
        setCurrentStyle(newStyle)
        // setBGColor(newStyle[':not(pre) > code[class*="language-"]'].background)
        setBGColor(newStyle.hljs.background)
      });
    }
  }, [styles])
  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 xl:gap-4">
      <div className="col-span-1 xl:col-auto">
        <div className=" h-full p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>Code Input</h3>
          </div>
          <div className="px-4 py-2 text-gray-400 border-dashed rounded dark:border-gray-600">
            <div className="col-span-full xl:col-auto mb-4" >
              <StyledSelect appTheme={appTheme} className='w-2/4 sm:w-full inline-block' value={language} options={commonFunc.langOptions} onChange={handleLangSelectChange} />
              <button
                type="button"
                onClick={() => setOriginalinput('')}
                className="text-white sm:ml-0 sm:mt-2 ml-2 inline-block bg-gray-400 hover:bg-gray-500 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center items-center me-2 mb-2"
              >
                <FontAwesomeIcon icon={faEraser}/>
                &nbsp;Clear
              </button>
            </div>
            <Editor 
              height="45vh"
              value={originalInput}
              onChange={(value, event) => handleChangeOriginalInput(value)}
              placeholder="Enter code here"
              language={language?.value}
              defaultValue={originalInput}
              theme={editorTheme}
              className="block p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
          </div>
        </div>
      </div>
      <div className="col-span-2">
        <div className="h-full p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-yellow-600 p-2'>Image Preview</h3>
          </div>
          <div className="px-4 py-2">
            <div className="grid grid-cols-4 xl:grid-cols-4 xl:gap-4 mb-4">
              <div className="col-span-full xl:col-auto" >
                <StyledSelect appTheme={appTheme} className='w-2/4 sm:w-full inline-block mr-5' value={style} options={commonFunc.styleOptions} onChange={handleStyleSelectChange} />
              </div>
              <div className="col-span-full xl:col-auto" >
                <button
                  onClick={handleShowTooltipColor}
                  id="color-tooltip"
                  type="button"
                  className="text-gray-600 focus:ring-4 border border-gray-200 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-blue-800"
                  style={{background: color}}
                >
                  <span style={{color: 'transparent'}} width={40}>C</span>
                </button>
                <div
                  data-popover=""
                  id="popover-user-profile"
                  role="tooltip"
                  className="absolute z-10 invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-600"
                >
                  <div className="p-3">
                    <div className="mb-4 border-b border-gray-200 dark:border-gray-700">
                      <ul
                        className="flex flex-wrap -mb-px text-sm font-medium text-center"
                      >
                        <li className="me-2" role="presentation">
                          <button
                            className={colorTab === 0 ? `inline-block p-4 rounded-t-lg border-blue-600 border-b-2` : 'inline-block p-4 rounded-t-lg border-b-2'}
                            type="button"
                            onClick={() => setColorTab(0)}
                          >
                            Ready-to-use
                          </button>
                        </li>
                        <li className="me-2" role="presentation">
                          <button
                            className={colorTab === 1 ? `inline-block p-4 rounded-t-lg border-blue-600 border-b-2` : 'inline-block p-4 rounded-t-lg border-b-2'}
                            type="button"
                            onClick={() => setColorTab(1)}
                          >
                            Customize
                          </button>
                        </li>
                      </ul>
                      <div className='mt-4'>
                        { colorTab === 0 && <Select className='inline-block  w-full' value={selectBgColorReady} options={bgColorReady} onChange={handleSelectBgColorReadyChange} /> }
                        { colorTab === 1 && <ColorPicker value={color} onChange={setColor} /> }
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  onClick={handleShowTooltipSettings}
                  id="popover-settings-btn"
                  type="button"
                  className='inline-block ml-2 text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-blue-500 dark:text-gray-200 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800'
                >
                  <FontAwesomeIcon icon={faSliders}/>
                  &nbsp;Settings
                </button> 
                <div
                  data-popover=""
                  id="popover-settings"
                  role="tooltip"
                  className="absolute z-10 invisible inline-block w-64 text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-600"
                >
                  <div className="p-3">
                    <form className="max-w-sm mx-auto">
                      <div class="flex items-center ps-4  dark:border-gray-700">
                        <label
                          htmlFor="number-input"
                          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                        >
                          Width ({imageSettings.width})
                        </label>
                        <input min={500} max={2000} onChange={handleImageSettingsChange} name="width" type="range" value={imageSettings.width} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700" />
                      </div>
                      { !hasBackground && (
                        <div class="flex items-center ps-4  dark:border-gray-700">
                          <label
                            htmlFor="number-input"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                          >
                            Height ({imageSettings.height})
                          </label>
                          <input min={100} max={800} onChange={handleImageSettingsChange} name="height" type="range" value={imageSettings.height} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700" />
                        </div>
                      )}
                      <div class="flex items-center ps-4 mb-2  dark:border-gray-700">
                        <input
                          checked={hasBackground}
                          onChange={handleHasBackgroundChange}
                          id="checked-checkbox-2" type="checkbox"
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                        <label for="checked-checkbox-2" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Background</label>
                      </div>
                      
                      {hasBackground && (
                        <>
                          <div class="flex items-center ps-4  dark:border-gray-700">
                            <label
                              htmlFor="number-input"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                              Editor Width ({imageSettings.editorWidth})
                            </label>
                            <input min={100} max={800} onChange={handleImageSettingsChange} name="editorWidth" type="range" value={imageSettings.editorWidth} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700" />
                          </div>
                        </>
                      ) }
                      <div class="flex items-center ps-4  dark:border-gray-700">
                        <label
                          htmlFor="number-input"
                          className="block mb-2 mt-2 text-sm font-medium text-gray-900 dark:text-white"
                        >
                          Starting Line Number
                        </label>
                        <input
                          type="number"
                          id="number-input"
                          aria-describedby="helper-text-explanation"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          placeholder={200}
                          required={true}
                          min={0}
                          value={imageSettings.startingLineNumber}
                          name="startingLineNumber"
                          onChange={handleImageSettingsChange}
                        />
                      </div>
                      <div class="flex items-center ps-4  dark:border-gray-700">
                        <input onChange={handleImageSettingsCheckbox} checked={imageSettings.wrapLines} id="bordered-checkbox-2" type="checkbox" value="" name="wrapLines" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                        <label for="bordered-checkbox-2" class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Wrap Lines</label>
                      </div>
                      <div class="flex items-center ps-4  dark:border-gray-700">
                        <input onChange={handleImageSettingsCheckbox} checked={imageSettings.showLineNumbers} id="bordered-checkbox-2" type="checkbox" value="" name="showLineNumbers" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                        <label for="bordered-checkbox-2" class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Show Line Numbers</label>
                      </div>
                      <div class="flex items-center ps-4  dark:border-gray-700">
                        <input onChange={handleImageSettingsCheckbox} checked={imageSettings.showInlineLineNumbers} id="bordered-checkbox-2" type="checkbox" value="" name="showInlineLineNumbers" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                        <label for="bordered-checkbox-2" class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Show Inline Line Numbers</label>
                      </div>
                      <div class="flex items-center ps-4  dark:border-gray-700">
                        <button
                          type="button"
                          onClick={handleResetToDefault}
                          className="text-white bg-gray-500 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
                        >
                          <FontAwesomeIcon icon={faRefresh}/>
                          &nbsp;Reset to default
                        </button>
                      </div>
                    </form> 
                  </div>
                </div> 
              </div>
              <div className="col-span-full xl:col-auto" >
                <select
                  id="aspect-ratio-select"
                  value={aspectRatio}
                  onChange={(e) => handleChangeAspectRatio(e)}
                  className='bg-gray-50 w-full inline-block border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                >
                  <option value="9:16">9:16 (Portrait)</option>
                  <option value="16:9">16:9 (Landscape)</option>
                  <option value="1:1">1:1 (Square)</option>
                </select>
              </div>
              <div className="col-span-full xl:col-auto" >
                <input
                  type="text"
                  value={downloadFileName}
                  onChange={(e) => setDownloadFileName(e.target.value)}
                  className="p-2.5 w-1/2 z-20 text-sm text-gray-900 bg-gray-50 rounded-lg rounded-s-gray-100 rounded-s-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500"
                  placeholder='File Name'
                />
                <button
                  type="button"
                  onClick={handleDownload}
                  className="text-white ml-2 inline-block bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center items-center me-2 mb-2"
                >
                  <FontAwesomeIcon icon={faCloudArrowDown}/>
                  &nbsp;
                </button>
              </div>
            </div>
            <div className="flex justify-center w-full">
              <div
                ref={codeRef}
                className='items-center border rounded-lg justify-center flex'
                style={{
                  height: imageSettings.height ? `${imageSettings.height}px` : 'auto',
                  width: `${imageSettings.width}px`,
                  background: color,
                  // paddingTop: `${imageSettings.paddingY}px`,
                  // paddingBottom: `${imageSettings.paddingY}px`,
                  // paddingLeft: `${imageSettings.paddingX}px`,
                  // paddingRight: `${imageSettings.paddingX}px`
                }}
              >
                <div
                  style={{
                    backgroundColor: bgColor,
                    width: `${imageSettings.editorWidth}px`,
                    height: !hasBackground ? `${imageSettings.height}px` : 'auto',
                  }}
                  className='border rounded-lg px-5 py-5 border-transparent'
                >
                  <div className="jsx-4023755556 window-controls">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={54}
                      height={14}
                      viewBox="0 0 54 14"
                    >
                      <g fill="none" fillRule="evenodd" transform="translate(1 1)">
                        <circle
                          cx={6}
                          cy={6}
                          r={6}
                          fill="#FF5F56"
                          stroke="#E0443E"
                          strokeWidth=".5"
                        />
                        <circle
                          cx={26}
                          cy={6}
                          r={6}
                          fill="#FFBD2E"
                          stroke="#DEA123"
                          strokeWidth=".5"
                        />
                        <circle
                          cx={46}
                          cy={6}
                          r={6}
                          fill="#27C93F"
                          stroke="#1AAB29"
                          strokeWidth=".5"
                        />
                      </g>
                    </svg>
                  </div>
                  {/* <SyntaxHighlighter
                    customStyle={{ padding: 10, fontFamily: imageSettings.fontFamily }}
                    language={language?.value || 'javascript'}
                    style={currentStyle}
                    wrapLines={imageSettings.wrapLines}
                    showLineNumbers={imageSettings.showLineNumbers}
                    showInlineLineNumbers={imageSettings.showInlineLineNumbers}
                    startingLineNumber={imageSettings.startingLineNumber}
                  >
                    {originalInput}
                  </SyntaxHighlighter> */}
                  <EditableCodeHighlighter
                    ref={editorPreview}
                    initialCode={originalInput}
                    customStyle={{ padding: 10, fontFamily: imageSettings.fontFamily }}
                    language={language?.value || 'javascript'}
                    style={currentStyle}
                    wrapLines={imageSettings.wrapLines}
                    showLineNumbers={imageSettings.showLineNumbers}
                    showInlineLineNumbers={imageSettings.showInlineLineNumbers}
                    startingLineNumber={imageSettings.startingLineNumber}
                    dynamicStyle={currentStyle}
                    onChange={(value, event) => setOriginalinput(value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CodeToImagePage;
